import { createFileRoute } from '@tanstack/react-router';
import WithdrawOtp from 'components/Otp/WithdrawOtp/WithdrawOtp';
import { SEO } from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import messages from '../../../../messages';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

const searchParamsSchema = z.object({
  acceptAbsolution: z.boolean().default(false),
  otpType: z.string(),
});

export const Route = createFileRoute(
  '/_authenticated/funds/withdraw/fiat/$productCode/2fa',
)({
  component: BankWithdraw2FA,
  validateSearch: zodValidator(searchParamsSchema),
});

function BankWithdraw2FA() {
  const { productCode } = Route.useParams();
  const { acceptAbsolution, otpType } = Route.useSearch();

  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const fundsMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={fundsMessages.title}
        description={fundsMessages.description}
        keywords={fundsMessages.keywords}
        page="/funds/withdraw/fiat/2FA"
      />
      <div className="px-6 py-4">
        <WithdrawOtp
          withdrawalType="fiat"
          otpType={otpType}
          acceptAbsolution={acceptAbsolution}
        />
      </div>
    </>
  );
}
